<neo-message *ngIf="neoTypeMessage(response) && response?.last_instruction_obj?.message"
             [messageType]="neoTypeMessage(response)"
             [message]="response?.last_instruction_obj?.message | newline"></neo-message>
